/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable functional/immutable-data */
import { useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'

export default function Index() {
  const { translate } = useLang()

  const forceRefresh = useHookstate(false)
  const name = useHookstate<string | null>(null)

   useEffect(() => {
      document.title = translate('Resources - Dispatch System')
    }, [])

  const inspectionItemFilter = [
    {
      name: 'name',
      type: 'name',
      placeholder: translate('Item Name'),
      variable: name,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="inspection-item"
        title={translate('Inspection Items')}
        disableColumnsFilters
        viewTitle={translate('Inspection Items')}
        canView={true}
        showInViewMore={['name', 'created_at']}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={inspectionItemFilter}
        clearFilters={() => {
          name.set('')
          forceRefresh.set(!forceRefresh.get())
        }}
        notSortable={[]}
        forceOrderColumns={['name']}
        exceptColumns={['deleted_at', 'updated_at']}
      />
    </Layout>
  )
}
